import { type User } from "@internal/user";
import { MetricFormatters } from "@north-beam/nb-client-side";

import { type Kpi } from "../../explore-budgets/client-setting/types";

export const formatKpi = (
  kpiType: Kpi["kpi_type"],
  val: number,
  user: User,
) => {
  if (kpiType === "price_value") {
    return MetricFormatters.currency(
      Number(val),
      user.currencies.currentCurrency,
      {
        precision: "approximate",
      },
    );
  } else {
    return MetricFormatters.decimal(
      Number(val),
      user.currencies.currentCurrency,
      {
        precision: "approximate",
      },
    );
  }
};
